module.exports = __webpack_public_path__ + "img/image14.34c31984.png";